import { SwiperContainer, register } from 'swiper/element/bundle'
import { imageSwiperOptions } from './imageSliderOptions'
import { quoteSwiperOptions } from './quoteSliderOptions'
register()

function initializeSwipers(el: HTMLElement) {
  for (const swiperEl of el.querySelectorAll<SwiperContainer>(
    'swiper-container[init="false"].card-slider'
  )) {

    if (swiperEl.classList.contains('image-swiper')) {
      Object.assign(swiperEl, imageSwiperOptions)
    } else if (swiperEl.classList.contains('card-quote-swiper')) {
      Object.assign(swiperEl, quoteSwiperOptions)
    }
    swiperEl.initialize()
  }
}

initializeSwipers(document.body)

// Use a mutation observer to find new sliders and initialize them
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof HTMLElement) {
        initializeSwipers(node)
      }
    }
  }
})

observer.observe(document.body, {
  childList: true,
  subtree: true
})
